export const searchOptions = {
  radius: 9000, // meters
  type: ["address"]
}

export const fetchPredictionsDebounceMS = 200
